(() => {
  let button;

  const setInvoker = (e) => {
    const previousButtons = window.swinger.$('[aria-controls="swinger-overlay-address-book-edit-overlay"][data-invoker]');
    previousButtons.forEach((button) => button.removeAttribute('data-invoker'));

    button = window.swinger.eventHub.getTarget(e);
    button.setAttribute('data-invoker', '');
  };

  window.swinger.eventHub.register('click', '[aria-controls="swinger-overlay-address-book-edit-overlay"]'
    + '', setInvoker);

  window.swinger.observer.initialize('.swinger-overlay-address-book-edit-overlay', (elem) => {
    window.swinger.visibility.observe(elem, (isVisible) => {
      if (isVisible) {
        window.swinger.overlayManager.register(elem, () => {
          window.setTimeout(() => {
            button.focus();
            elem.querySelector('[class$="__close"]').click();
          });
        }, button, false);
      } else {
        window.swinger.overlayManager.unregister(elem);
        window.setTimeout(() => {
          if (button) {
            button.focus();
          }
        });
      }
    });
  }, false);

  const handlePackstation = (elem) => {
    const overlay = elem.closest('.swinger-overlay-address-book-edit-overlay');
    const fieldset = overlay.querySelector('.swinger-form-fieldset');
    const wrapper = overlay.querySelector('.swinger-wrapper');
    const country = overlay.querySelector('[name="country"]');
    const standardInvoiceAddress = overlay.querySelector('[name="isDefault\\[\\]"][value="billingAddress"]');
    const isPackStation = elem.checked;

    window.swinger.$('input', fieldset).forEach((input) => {
      input.disabled = !isPackStation;
    });
    fieldset.style.display = isPackStation ? '' : 'none';

    window.swinger.$('input', wrapper).forEach((input) => {
      input.disabled = isPackStation;
    });
    wrapper.style.display = isPackStation ? 'none' : '';

    if (isPackStation) {
      if (country.value) {
        country.setAttribute('data-previous-value', country.value);
      }
      country.querySelector('option[value="DE"]').selected = true;
    } else if (country.hasAttribute('data-previous-value')) {
      const previousValue = country.getAttribute('data-previous-value');
      const option = country.querySelector(`option[value="${previousValue}"]`);
      if (option) {
        option.selected = true;
      }
      country.removeAttribute('data-previous-value');
    }

    country.disabled = isPackStation;

    if (isPackStation) {
      if (standardInvoiceAddress.checked) {
        standardInvoiceAddress.setAttribute('data-previously-checked', '');
      }
      standardInvoiceAddress.checked = false;
    } else if (standardInvoiceAddress.hasAttribute('data-previously-checked')) {
      standardInvoiceAddress.checked = true;
      standardInvoiceAddress.removeAttribute('data-previously-checked');
    }

    standardInvoiceAddress.disabled = isPackStation;
    standardInvoiceAddress.closest('.swinger-input').style.display = isPackStation ? 'none' : '';
  };

  window.swinger.observer.initialize('.swinger-overlay-address-book-edit-overlay [name="isPackstation"]', handlePackstation, false);

  window.swinger.eventHub.register('change', '.swinger-overlay-address-book-edit-overlay [name="isPackstation"]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    handlePackstation(elem);
  }, false);
})();
